<div class="dropdownContainer">
    <div class="dropdownLink" (click)="toggleActions()">
        <button class="btn btn-sm m-r-xs" [class.active]="actionsOpened">
            <span *ngIf="labelKey"><span [i18n]="labelKey"></span>&nbsp;</span>
            <i class="fa fa-ellipsis-v"></i>
        </button>
    </div>

    <div [class]="'dropdown' + ' ' + fromPositionDropdown(positionDropdown)"
         [hidden]="!actionsOpened"
         [ngStyle]="{'z-index': 1000, 'min-width': width}">
        <ng-content></ng-content>
    </div>
</div>
